interface Params {
  [key: string]: string | string[] | number | boolean | undefined;
}
export function generateParams(params: Params): string {
  let result = '?';
  const queryParams: string[] = [];
  const paramsArray = Object.entries(params);
  for (const [key, value] of paramsArray) {
    if (key && key !== 'tab' && value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0)) {
      queryParams.push(`${key}=${value}`);
    }
  }

  if (queryParams.length > 0) {
    result += queryParams.join('&');
  }

  return result;
}
